import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import s from './footer.module.css';
import { PRIVACY_LINKS, TERMS_OF_USE_LINKS } from '../../constants/footerLinks';
import { retailerSettingsService } from '../../services/retailer-settings/retailer-settings';

export const mapStateToProps = ({ page: { languageCode }, language }) => ({
  termsLink:
    language['returns.validate.footer.terms_of_use_link'] ||
    TERMS_OF_USE_LINKS[languageCode] ||
    TERMS_OF_USE_LINKS.en,
  termsText: language['returns.validate.footer.terms_of_use'] || 'Terms of Use',
  privacyLink:
    language['returns.validate.footer.privacy_policy_link'] ||
    PRIVACY_LINKS[languageCode] ||
    PRIVACY_LINKS.en,
  privacyText: language['returns.validate.footer.privacy_policy'] || 'Privacy Policy',
});

const Footer = ({ termsLink, termsText, privacyLink, privacyText }) => {
  const retailerName = retailerSettingsService.getName();
  const product = 'R2';
  return (
    <div className={`container ${s.footer || ''}`} id="footer-nav">
      <footer className={`footerUpdateMobile ${s.footer_content || ''}`} role="contentinfo">
        <div className="carousel marginBottomNone">
          <a
            href={`https://corp.narvar.com/survey?product=${product}&retailer_name=${retailerName}`}
            target="_blank"
            rel="noopener noreferrer"
            className={`footer-logo-link ${s.footer_logo || ''}`}
            data-advid="narvar_home_mobile"
            aria-label="Powered by Narvar"
          >
            <img
              className="footer-logo"
              src="https://assets.narvar.com/retailers/general/footer_logo@2x.png"
              srcSet="https://assets.narvar.com/retailers/general/footer_logo@2x.png, https://assets.narvar.com/retailers/general/footer_logo@2x.png 2x"
              width="102"
              alt="Powered by Narvar"
            />
          </a>
          <p className={`footer-info ${s.footer_link_container || ''}`}>
            <a
              href={termsLink || ''}
              className={`footer-link-terms banner_ad_link ui-link ${s.footer_link || ''}`}
              data-advid="terms_of_use_mobile"
              target="_blank"
              rel="noopener noreferrer"
            >
              {termsText}
            </a>
            {` | `}
            <a
              href={privacyLink || ''}
              className={`footer-link-policy banner_ad_link ui-link ${s.footer_link || ''}`}
              data-advid="privacy_policy_mobile"
              target="_blank"
              rel="noopener noreferrer"
            >
              {privacyText}
            </a>
          </p>
        </div>
      </footer>
    </div>
  );
};

Footer.propTypes = {
  termsLink: PropTypes.string.isRequired,
  privacyLink: PropTypes.string.isRequired,
  termsText: PropTypes.string.isRequired,
  privacyText: PropTypes.string.isRequired,
};

export default connect(mapStateToProps)(Footer);
